export enum ProjectedHeadcountSelectedMethod {
  Year5 = 1,
  AnnualGrowthModel = 2
}